import { useContext } from 'react';
import { StoreContext } from '~/stores/root-store.provider';
import { ensureRootStoreInit } from '~/stores/root-store.utils';
import type { RootStore } from '~/stores/root.store';
import type { TRootStore } from '~/types/app.types';

export function useRootStore(): RootStore {
    const rootStore = useContext<TRootStore>(StoreContext) as RootStore;

    ensureRootStoreInit(rootStore);

    return rootStore;
}
